import React from 'react';
import {useRsvp} from '../context/RsvpContext';
import CustomButton from "./CustomButton";

const Invitation: React.FC = () => {
    const {rsvp} = useRsvp();
    const passes = rsvp?.allowedGuests ?? 0;
    const pases = passes > 1 ? " pases": " pase";
    const disponibles = passes > 1 ? " disponibles.": " disponible.";
    const numPases ="Tienes " + passes?.toString() + pases + disponibles;

    return (
        <section>
            <div
                className="flex text-center md:mt-24 pt-20 bg-[url('assets/images/beach.jpg')] bg-cover bg-center place-content-center">
                <img src="objects/Lyrics1.png" alt="Glamping"
                     className="absolute h-[20dvh] top-4 right-0 md:right-[10svw] md:top-[12svh] md:h-[40dvh]"/>
                <div
                    className="p-16 w-[80dvw] h-[91dvw] md:w-[50dvw] md:h-[41dvw] md:mb-40 bg-[url('assets/images/RSVPPostal.png')] bg-cover bg-center place-content-center">
                    <div className="md:ml-[12%] md:mr-[16%] md:mt-[10%] -ml-[15%] -mr-[10%] mt-[35%]">
                        <p className="parrafo-regular">
                            ¡Por favor confirma tu asistencia!
                        </p>
                        {passes !== undefined && (
                            <p className="md:text-lg md:mb-8 mb-4 mt-4 text-[#4c6a4d]">{numPases}</p>
                        )}
                        <CustomButton
                            text={'RSVP'}
                            onClick={() => window.location.href = '/rsvp'}
                            bgColor={'bg-[#8a2c47]'}
                            hoverColor={'hover:bg-(--hover-color)'}
                            rounded={'rounded-full'}
                        />
                    </div>
                </div>
            </div>
            <div
                className="flex text-center h-lvh bg-[url('assets/images/hug.jpg')] bg-cover bg-center place-content-center">
                <div className="relative inset-0 bg-gradient-to-t from-black h-full w-full bg-cover bg-center place-content-center">
                    <img src="objects/Lyrics2.png" alt="Glamping"
                         className="absolute h-[15dvh] top-[15dvh] left-4 md:left-[10svw] md:top-[20svh] md:h-[30dvh]"/>
                    <img src="objects/Lyrics3.png" alt="Glamping"
                         className="absolute h-[5dvh] w-[65svw] top-[90svh] left-[20svw] md:h-[10svh] md:w-[30svw] md:top-[85svh] md:left-[60svw]"/>
                </div>
            </div>
        </section>
    );
};

export default Invitation;
